import { Component, Input } from '@angular/core';
import { FirestoreService } from '../firestore-service.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-feedbackpopup',
    templateUrl: './feedbackpopup.component.html',
    styleUrls: ['./feedbackpopup.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule]
})
export class FeedbackpopupComponent {
  isMinimazed = true
  isVisible = true
  feedbackContent = ""
  @Input()userId = ""
  @Input()email = ""
  @Input()organizationKey = ""
  @Input()projectKey = ""

  constructor(private firestore: FirestoreService) {

  }

  maximize() {
    this.isMinimazed = !this.isMinimazed
  }

  close() {
    this.isVisible = false
  }

  send() {
    this.firestore.addUserStartWizardFeedback(this.userId, this.feedbackContent, this.email, this.organizationKey, this.projectKey).then(() => {
      this.firestore.showSnackBar("Thanks for sending as message. It will help us improve Wroolo for you.")
    })
    this.isVisible = false
  }
 }
